import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { removeUser } from 'store/Admin/UserManagement';

import axiosPrivate from 'config/axiosPrivate';

import { ROLES } from 'utils/Constants';
import ErrorSuccesModal from 'components/shared/modal/ErrorSuccesModal';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import { useTranslation } from 'react-i18next';
import { removeGlobalUser } from 'store/AdminClient/CLientAdminManagement';

const DELETE_USER_URL = '/user/';

export const DeleteUser = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [errorSuccess, setErrorSuccess] = useState(false);
  const [errorSuccessMsg, setErrorSuccessMsg] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const [confirmation, setConfirmation] = useState(false);
  const [confirmationMsg, setConfirmationMsg] = useState('');

  const [role, setRole] = useState('');

  useEffect(() => {
    switch (props.selected?.role) {
      case ROLES.CLIENT:
        setRole('le client');
        break;
      case ROLES.CONSULTANT:
        setRole('le consultant');
        break;
      case ROLES.ADMIN:
        setRole("l'admin");
        break;
      case ROLES.WRITER:
        setRole('le rédacteur');
        break;
      default:
        setRole(`L'utilisateur`);
        break;
    }

    setConfirmation(true);
  }, [props.selected]);

  useEffect(() => {
    setConfirmationMsg(
      `${t('Voulez-vous vraiment supprimer')} ${t(role)} ${
        props.selected?.mail
      } ?`
    );
  }, [role, props.selected, t]);

  const deleteUser = () =>
    axiosPrivate
      .delete(DELETE_USER_URL + props.selected.mail, {
        params: { role: props.selected.role },
      })
      .then(() => {
        setConfirmation(false);
        if (!props.flag) {
          dispatch(removeUser(props.selected.mail));
          //dispatch(removeGlobalUser(props.selected.mail));
        } else {
          props.onDelete(props.selected.mail);
        }
        setIsSuccess(true);

        setErrorSuccessMsg(
          `${t(role)} ${props.selected.mail} ${t(
            'a été supprimé avec succès'
          )} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setConfirmation(false);
        setIsSuccess(false);
        switch (props.selected.role) {
          case ROLES.CLIENT:
            setErrorSuccessMsg(
              e.response.status === 409
                ? `${t('Le client')} ${props.selected.mail} ${t(
                    "est le seul client pour un site, il faut ajouter d'autres pour pouvoir le supprimer"
                  )}.`
                : t("Oups....! Une erreur s'est produite")
            );
            break;

          case ROLES.CONSULTANT:
            setErrorSuccessMsg(
              e.response.status === 409
                ? `${t('Le consultant')} ${props.selected.mail} ${t(
                    'ne peut pas être supprimé car il est lié à des sites web'
                  )}.`
                : t("Oups....! Une erreur s'est produite")
            );
            break;

          case ROLES.WRITER:
            setErrorSuccessMsg(
              e.response.status === 409
                ? `${t('Vous ne pouvez pas supprimer le rédacteur')} ${
                    props.selected.mail
                  } ,${t('car celui-ci a déjà rédigé des textes')}.`
                : t("Oups....! Une erreur s'est produite")
            );
            break;

          default:
            setErrorSuccessMsg(
              `${t(role)} ${props.selected.mail} ${t(
                'ne peut pas être supprimé pour le moment'
              )}`
            );
            break;
        }
        setErrorSuccess(true);
      });

  return (
    <div>
      <ErrorSuccesModal
        open={errorSuccess}
        message={errorSuccessMsg}
        handleClose={() => setErrorSuccess(false)}
        success={isSuccess}
        toggle={() => setErrorSuccess(!errorSuccess)}
      />

      <ConfirmationModal
        open={confirmation}
        message={confirmationMsg}
        handleClose={() => props.Close()}
        executeAction={() => {
          deleteUser();
        }}
      />
    </div>
  );
};
